import { z } from 'zod';

import { wholeIn } from './fields';

export const departmentSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { error: 'chatSettings:validation.nameRequired' })
    .max(80, { error: 'chatSettings:validation.max80' }),
  description: z.string().trim().max(300, { error: 'chatSettings:validation.max300' }),
  position: wholeIn(0, 1000, 'chatSettings:validation.position'),
  isDefault: z.boolean(),
  memberIds: z.array(z.string()).max(200),
});

export type DepartmentForm = z.infer<typeof departmentSchema>;
